module.exports = __webpack_public_path__ + "img/disk_banner.5411bf11.png";